import { NavLink } from 'react-router-dom';
import useNotificationStore from '@/store/notificationStore';

function MapIcon({ active }) {
  const c = 'currentColor';
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-6 w-6" aria-hidden>
      <path d="M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3V6Z" fill={active ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.05)'} stroke={c} strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M9 3v15M15 6v15" stroke={c} strokeWidth="1" opacity="0.6"/>
      {active && <circle cx="12" cy="11" r="2" fill="currentColor" opacity="0.8"/>}
    </svg>
  );
}

function MissionsIcon({ active }) {
  const c = 'currentColor';
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-6 w-6" aria-hidden>
      <rect x="5" y="3" width="14" height="18" rx="2" fill={active ? 'rgba(255,255,255,0.12)' : 'rgba(255,255,255,0.05)'} stroke={c} strokeWidth="1.5"/>
      <path d="M8 8h8M8 12h8M8 16h5" stroke={c} strokeWidth="1.2" strokeLinecap="round"/>
      <path d="M5 7l-1.5-1.5" stroke={c} strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
      <path d="M5 12H3" stroke={c} strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
      {active && <circle cx="19" cy="5" r="2.5" fill="#EF4444"/>}
    </svg>
  );
}

function CharactersIcon({ active }) {
  const c = 'currentColor';
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-6 w-6" aria-hidden>
      <circle cx="12" cy="8" r="3.5" fill={active ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.05)'} stroke={c} strokeWidth="1.5"/>
      <path d="M5 20c0-3.5 3-6 7-6s7 2.5 7 6" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      {active && <circle cx="12" cy="8" r="1.2" fill="currentColor"/>}
    </svg>
  );
}

function RankingIcon({ active }) {
  const c = 'currentColor';
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-6 w-6" aria-hidden>
      <rect x="2" y="12" width="5" height="10" rx="1" fill={active ? 'rgba(255,255,255,0.12)' : 'rgba(255,255,255,0.05)'} stroke={c} strokeWidth="1.4"/>
      <rect x="9.5" y="7" width="5" height="15" rx="1" fill={active ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.08)'} stroke={c} strokeWidth="1.4"/>
      <rect x="17" y="10" width="5" height="12" rx="1" fill={active ? 'rgba(255,255,255,0.12)' : 'rgba(255,255,255,0.05)'} stroke={c} strokeWidth="1.4"/>
      {active && (
        <>
          <polygon points="12,2 13,5 16,5 13.5,7 14.5,10 12,8 9.5,10 10.5,7 8,5 11,5" fill="currentColor" opacity="0.9"/>
        </>
      )}
    </svg>
  );
}

function FriendsIcon({ active }) {
  const c = 'currentColor';
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-6 w-6" aria-hidden>
      <circle cx="9" cy="7" r="4" fill={active ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.05)'} stroke={c} strokeWidth="1.5"/>
      <path d="M2 21c0-4 3-7 7-7s7 3 7 7" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="19" cy="8" r="2.5" fill={active ? 'rgba(255,255,255,0.1)' : 'transparent'} stroke={c} strokeWidth="1.2"/>
      <path d="M22 20c0-2.2-1.3-4-3-4.5" stroke={c} strokeWidth="1.2" strokeLinecap="round"/>
    </svg>
  );
}

function OffersIcon({ active }) {
  const c = 'currentColor';
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-6 w-6" aria-hidden>
      <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8 8a2 2 0 0 0 2.828 0l7-7a2 2 0 0 0 0-2.828l-8-8Z"
        fill={active ? 'rgba(255,255,255,0.18)' : 'rgba(255,255,255,0.05)'}
        stroke={c} strokeWidth="1.5" strokeLinejoin="round"/>
      <circle cx="7.5" cy="7.5" r="1.5" fill={c}/>
      {active && <path d="M8 14l6-6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.6"/>}
    </svg>
  );
}

const tabs = [
  { to: '/game/map', label: 'Mapa', Icon: MapIcon, color: '#FF6A00', deep: '#C84600' },
  { to: '/game/characters', label: 'Pessoas', Icon: CharactersIcon, color: '#A855F7', deep: '#7E22CE' },
  { to: '/game/missions', label: 'Missões', Icon: MissionsIcon, color: '#22C55E', deep: '#15803D' },
  { to: '/game/ranking', label: 'Ranking', Icon: RankingIcon, color: '#FACC15', deep: '#CA8A04' },
  { to: '/game/friends', label: 'Amigos', Icon: FriendsIcon, color: '#38BDF8', deep: '#0284C7' },
  { to: '/game/shop', label: 'Ofertas', Icon: OffersIcon, color: '#F43F5E', deep: '#BE123C' },
];

export default function BottomNav() {
  const { unreadCount, friendRequestCount, offerCount } = useNotificationStore();

  return (
    <nav className="bottom-nav">
      <div className="flex" style={{ height: 'var(--bottom-nav-base-height)' }}>
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              `relative flex flex-1 flex-col items-center justify-center gap-1 transition-all duration-200 ${
                isActive ? 'text-accent' : 'text-muted'
              }`
            }
          >
            {({ isActive }) => (
              <>
                {/* indicador topo */}
                {isActive && (
                  <span
                    className="absolute left-1/2 top-0 h-[3px] w-9 -translate-x-1/2 rounded-full"
                    style={{ background: `linear-gradient(90deg, transparent, ${tab.color}, transparent)` }}
                  />
                )}

                {/* ícone dentro de bolha 3D colorida quando ativo */}
                <span
                  className="flex h-9 w-9 items-center justify-center rounded-2xl transition-all duration-200"
                  style={isActive ? {
                    color: '#fff',
                    background: `linear-gradient(180deg, ${tab.color} 0%, ${tab.deep} 100%)`,
                    boxShadow: `inset 0 1.5px 0 rgba(255,255,255,0.45), 0 3px 0 ${tab.deep}, 0 6px 14px ${tab.color}66`,
                    transform: 'translateY(-4px)',
                  } : { color: 'rgb(var(--hc-muted))' }}
                >
                  <tab.Icon active={isActive} />
                </span>

                <span
                  className="text-[9px] font-black tracking-wide leading-none transition-colors duration-200"
                  style={{ fontFamily: '"Syne", sans-serif', color: isActive ? tab.color : 'rgb(var(--hc-muted))' }}
                >
                  {tab.label}
                </span>

                {/* badges de notificação */}
                {tab.to === '/game/missions' && unreadCount > 0 && (
                  <span className="absolute right-2 top-1.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-red-600 px-1 text-[9px] font-black text-white shadow-[0_0_6px_rgba(220,38,38,0.6)]">
                    {unreadCount}
                  </span>
                )}
                {tab.to === '/game/friends' && friendRequestCount > 0 && (
                  <span className="absolute right-2 top-1.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-red-600 px-1 text-[9px] font-black text-white shadow-[0_0_6px_rgba(220,38,38,0.6)]">
                    {friendRequestCount}
                  </span>
                )}
                {tab.to === '/game/shop' && offerCount > 0 && (
                  <span className="absolute right-2 top-1.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-red-600 px-1 text-[9px] font-black text-white shadow-[0_0_6px_rgba(220,38,38,0.6)]">
                    {offerCount}
                  </span>
                )}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
